const CardContainer = ({ avatarImageUrl, personName, roleTitle }) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-start gap-[4px] text-left text-8xl text-dark font-footnote sm:flex-[unset] sm:self-stretch">
      <img
        className="relative rounded-61xl w-[120px] h-[120px] object-cover"
        alt=""
        src={avatarImageUrl}
      />
      <b className="relative tracking-[-0.02em] leading-[40px]">{personName}</b>
      <div className="relative leading-[40px] font-h2-accent">{roleTitle}</div>
    </div>
  );
};

export default CardContainer;
